/**
 * Foreground decorative layer of the hero — reserved for per-sport
 * elements (baseball bat + ball, basketball hoop, hockey stick, …) that
 * float around the pack. The designer may deliver these as a separate
 * Lottie or fold them into the `HeroBackdrop` file; the split is kept now
 * so we can adopt either shape without refactoring the hero.
 *
 * Empty render until assets arrive. `pointer-events-none` so clicks pass
 * through to whatever sits underneath (nothing interactive here anyway).
 */
export interface HeroOverlayProps {
  /** Second optional Lottie URL for the decorative sport elements. */
  animationUrl: string | null;
}

export function HeroOverlay({ animationUrl: _animationUrl }: HeroOverlayProps) {
  return (
    <div
      data-hero-slot="overlay"
      aria-hidden
      className="pointer-events-none absolute inset-0"
    />
  );
}
